import { render, staticRenderFns } from "./AttachedToPositionsTab.vue?vue&type=template&id=ab5e0f6e&scoped=true"
import script from "./AttachedToPositionsTab.vue?vue&type=script&lang=js"
export * from "./AttachedToPositionsTab.vue?vue&type=script&lang=js"
import style0 from "./AttachedToPositionsTab.vue?vue&type=style&index=0&id=ab5e0f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5e0f6e",
  null
  
)

export default component.exports